import { Component, Input } from '@angular/core';
import { FileDownloadDataServiceProvider } from '../../../../../shared/services/files/file-download-service/file-download.data.service';

@Component({
	selector: 'save-pdf-btn',
	template: require('./save-pdf-btn.html')
})
export class SavePdfBtnComponent {
	@Input() link: string;
	@Input() id: number;
	@Input() docType: string;

	isSpinnerActive: boolean;

	constructor(
		private fileDownloadDataService: FileDownloadDataServiceProvider
	) {}

	saveAsPdf(): void {
		this.isSpinnerActive = true;
		this.fileDownloadDataService
			.downloadPdf(this.link, this.id, this.docType)
			.then(() => (this.isSpinnerActive = false))
			.catch(() => (this.isSpinnerActive = false));
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/buttons/save-pdf-btn/save-pdf-btn.ts